import MultiButtonSwitch from "../../../components/common/editors/MultiButtonSwitch";

export default function FragmentSourceEditor({ value, onChange }) {
    return <span className=''>
      <MultiButtonSwitch value={value} onChange={onChange} options={[{ label: 'Human', value: 'human' }, { label: 'LLM', value: 'llm' }, { label: 'Web', value: 'web' }]} />
    </span>;
  }